// charMatchAll :: list => string => boolean
export const charMatchAll = (charlist, target) => charlist.map((char) => char === target);

// stringMap :: function => string => string
export const stringMap = (f) => (string) => string.split('').map(f).join('');

// stringFilter :: predicate => string => string
export const stringFilter = (p) => (string) => string.split('').filter(p).join('');

// isWithinNumRange :: (number, number) => number => boolean
export const isWithinNumRange = (min, max) => (val) => val >= min && val <= max;

// objMap :: (object, function) => object
export const objMap = (o, f) => {
    let res = {};
    for (let key of Object.keys(o)) {
        res[key] = f(o[key]);
    }
    return res;
};

export const removeCharacters = (lettersToRemove, str) => {
    lettersToRemove.forEach((letter) => {
        str = str.replaceAll(letter, '');
    });
    return str;
};

// generateDefaults :: (string, list) => object
export const generateDefaults = (fallback, ids) =>
    ids.map((id) => ({ [id]: fallback })).reduce((a, b) => Object.assign(a, b));
